import React from 'react';

export default ({value = '', label, ...rest}) => (
	<label className='Textarea'>
		{ label ? <div className='Textarea_label'>{label}</div> : null }
		<textarea value={value} {...rest}/>
	</label>
);